var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('div',[_c('el-tag',{attrs:{"size":_vm.size,"type":_vm.postTag.type}},[_vm._v(_vm._s(_vm.postTag.label))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }